// extracted by mini-css-extract-plugin
export default {"td":"rFxC7Epr6WqJ1XL9Hafp","tr":"DcH8MhTQemok3jZjzC1V"};